module.exports = __webpack_public_path__ + "img/hero_image_rights_services.74f5d06.jpg";